import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

function Content({ 
  name, isSticky = false, scrollIntoView = true,
  style, 
  styleHeader, stickyClassName = '',
  showTitle = true, titleClassName = '',
  subContent = null, 
  contentClassName = null,
  children
}) {
  const ref = useRef();
  const isBrowserOptimal = useSelector(state => state.isBrowserOptimal);

  //The element may not be scrolled completely to the top depending on the layout of other elements.
  useEffect( () => {
    if (ref && isSticky && scrollIntoView && isBrowserOptimal) {
      ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, [name, isSticky, scrollIntoView, isBrowserOptimal])

  const isScrolling = useSelector(state => state.isScrolling);

  return (
    <div ref={ref} className={`content`} style={{...style}} >
      <div className={`flexRow align-center ${(isSticky) ? `content-top-sticky ${stickyClassName}` : null} ${(isScrolling) && 'is-scrolling'} `} style={{gap: 25, ...styleHeader}}>
        {showTitle && <span className={`type-title type-light content-text ${titleClassName}`}>{name}</span> }
        {subContent && subContent}
      </div>
      <div className={contentClassName}>
        { React.Children.map(children, child => (React.isValidElement(child)) && React.cloneElement(child)) }
      </div>
    </div>
  )
}

Content.propTypes = {
  name: PropTypes.string.isRequired,
  isSticky: PropTypes.bool,
  stickyClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  style: PropTypes.object,
  styleHeader: PropTypes.object
}

export default Content;
